import { render, staticRenderFns } from "./CareInvoiceRev1.vue?vue&type=template&id=73ef9bdf&"
import script from "./CareInvoiceRev1.vue?vue&type=script&lang=ts&"
export * from "./CareInvoiceRev1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSelect,VSpacer})
